const ThumbsUp = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='72.702'
    height='73.647'
    viewBox='0 0 72.702 73.647'
    fill='#0e77ef'
    {...props}
  >
    <path
      id='thumbs_up'
      data-name='thumbs up'
      d='M70.589,27.451a13.774,13.774,0,0,0-2.98-2.627,8.457,8.457,0,0,0-3.686-1.373h-17.1V13.412A12.927,12.927,0,0,0,42.9,3.922,12.927,12.927,0,0,0,33.412,0a3.7,3.7,0,0,0-1.843.51,2.269,2.269,0,0,0-1.137,1.529L18.039,30.118h-8a9.666,9.666,0,0,0-7.177,2.9A9.77,9.77,0,0,0,0,40.157V63.608a9.77,9.77,0,0,0,2.863,7.137,9.666,9.666,0,0,0,7.177,2.9H57.883a9.494,9.494,0,0,0,6.51-2.431,10.961,10.961,0,0,0,3.529-5.961l4.706-30.118a10.775,10.775,0,0,0-2.039-7.686ZM16.706,66.9H10.039A3.338,3.338,0,0,1,7.569,66a3.233,3.233,0,0,1-.9-2.392V40.157a3.369,3.369,0,0,1,.9-2.431,3.26,3.26,0,0,1,2.471-.941h6.667Zm44.471-2.667A3.119,3.119,0,0,1,60.04,66.2a3.394,3.394,0,0,1-2.157.706H23.373V34.118L35.451,7.059a7.227,7.227,0,0,1,3.373,2.392,6.2,6.2,0,0,1,1.333,3.961V26.745a3.338,3.338,0,0,0,.9,2.471,3.233,3.233,0,0,0,2.392.9H63.216a2.092,2.092,0,0,1,1.333.431,11.4,11.4,0,0,1,1.02.9,1.909,1.909,0,0,1,.549,1.176A11,11,0,0,1,66.2,33.8Z'
    />
  </svg>
)

export default ThumbsUp
